module.exports = __webpack_public_path__ + "static/image3-82515f2ed8e0550aa281af23ef6ba3d3.jpg";